import { render, staticRenderFns } from "./CampaignPromotions.vue?vue&type=template&id=7f621a7e&scoped=true"
import script from "./CampaignPromotions.vue?vue&type=script&lang=js"
export * from "./CampaignPromotions.vue?vue&type=script&lang=js"
import style0 from "./CampaignPromotions.vue?vue&type=style&index=0&id=7f621a7e&prod&lang=scss&scoped=true"
import style1 from "./CampaignPromotions.vue?vue&type=style&index=1&id=7f621a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f621a7e",
  null
  
)

export default component.exports